import { RouterModule, Routes }       from '@angular/router';

import { HomeComponent }              from './home/home.component';
import { LoginComponent }             from './login/login.component';
import { MonitoringComponent }        from './monitoring/monitoring.component';
import { BusListComponent }           from './bus-list/bus-list.component';
import { TrainListComponent }         from './train-list/train-list.component';
import { TrainCycleListComponent }    from './train-cycle-list/train-cycle-list.component';
import { KitchenListComponent }       from './kitchen-list/kitchen-list.component';
import { ProductListComponent }       from './product-list/product-list.component';
import { SupplierListComponent }      from './supplier-list/supplier-list.component';
import { EetComponent }               from './eet/eet.component';
import { UserListComponent }          from './user-list/user-list.component';
import { PeakListComponent }          from './peak-list/peak-list.component';
import { CompanyListComponent }       from './company-list/company-list.component';
import { AuthGuard }                  from './common/auth.guard';
import { OrderLogisticalComponent }   from './order-logistical/order.component';
import { PortalTypeEnum }             from './login/login.model';
import { BusRouteListComponent }      from './bus-route-list/bus-route-list.component';
import { HolidayExceptionListComponent } from './holiday-exception-list/holiday-exception-list.component';
import { SettingListComponent } from './setting-list/setting-list.component';
import { TrainClassListComponent } from './train-class-list/train-class-list.component';

// tslint:disable:max-line-length
const routes: Routes = [
  { path: '', redirectTo: 'monitoring', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, },
  { path: 'home', component: HomeComponent, canActivate: [ AuthGuard ]  },
  { path: 'monitoring', component: MonitoringComponent, canActivate: [ AuthGuard ] },
  { path: 'trasy', component: BusRouteListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Bus } },
  { path: 'spoje', component: TrainListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Train } },
  { path: 'spoje-cykly', component: TrainCycleListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Train } },
  { path: 'kuchynky', component: KitchenListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Train } },
  { path: 'autobusy', component: BusListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Bus } },
  { path: 'produkty', component: ProductListComponent, canActivate: [ AuthGuard ] },
  { path: 'eet', component: EetComponent, canActivate: [ AuthGuard ] },
  { path: 'uzivatele', component: UserListComponent, canActivate: [ AuthGuard ] },
  { path: 'spicky', component: PeakListComponent, canActivate: [ AuthGuard ] },
  { path: 'danove-subjekty', component: CompanyListComponent, canActivate: [ AuthGuard ] },
  { path: 'dodavatele', component: SupplierListComponent, canActivate: [ AuthGuard ] },
  { path: 'objednavky-logisticke', component: OrderLogisticalComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Train } },
  { path: 'vyjimky-prazdniny', component: HolidayExceptionListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Train } },
  { path: 'tridy', component: TrainClassListComponent, canActivate: [ AuthGuard ], data: { portalType: PortalTypeEnum.Train } },
  { path: 'nastaveni', component: SettingListComponent, canActivate: [ AuthGuard ] },
  { path: '**', component: LoginComponent}
];

export const routing = RouterModule.forRoot(routes, { enableTracing: true });



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/app.routing.ts